export default {
  footerLink: 'Configuración de cookies',
  consentModal: {
    title: 'Usamos cookies',
    description: 'Usamos un mínimo de cookies para que el sitio funcione, además de cookies opcionales de análisis y publicidad — solo con tu consentimiento.',
    acceptAllBtn: 'Aceptar todo',
    acceptNecessaryBtn: 'Rechazar todo',
    showPreferencesBtn: 'Gestionar preferencias',
  },
  preferencesModal: {
    title: 'Preferencias de cookies',
    acceptAllBtn: 'Aceptar todo',
    acceptNecessaryBtn: 'Rechazar todo',
    savePreferencesBtn: 'Guardar preferencias',
    closeIconLabel: 'Cerrar',
    sections: [
      {
        title: 'Necesarias',
        description: 'Estas cookies son necesarias para el funcionamiento del sitio y no se pueden desactivar.',
        linkedCategory: 'necessary',
      },
      {
        title: 'Análisis',
        description: 'Nos ayudan a entender cómo se usa el sitio para que podamos mejorarlo.',
        linkedCategory: 'analytics',
      },
      {
        title: 'Publicidad',
        description: 'Se utilizan para hacer los anuncios más relevantes. Solo se activan con tu consentimiento.',
        linkedCategory: 'ads',
      },
    ],
  },
}
